import React, {Component} from "react";
import PropTypes from 'prop-types';
import {Switch, Route, Redirect} from "react-router-dom";
import {connect} from 'react-redux';
import {loadAllData, loadSubstances} from "../redux/actions/local";
import { addPermissionsToUserSync } from '../helpers/permissions';
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

import NotificationSystem from "react-notification-system";
import Sidebar from "components/Sidebar/Sidebar.jsx";
import AdminNavbar from "components/Navbars/AdminNavbar.jsx";

import image from "assets/img/full-screen-image-3.jpg";

// style for notifications
import { style } from "helpers/NotificationStyles.jsx";

import routes from "routes/app.jsx";

let ps;


class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            _notificationSystem: null,
            image: image,
            color: "black",
            hasImage: true,
            navbar: false,
            mini: false,
            isLoading: false
        };

        this.mainPanel = React.createRef();
        this._notificationSystem = React.createRef();
    }

    async componentDidMount() {
        this.setState({ isLoading: true });
        try {
            // Chargement initial des données
            await this.props.loadAllData();
            await this.props.loadSubstances();
        } catch (error) {
            this.showNotification('Erreur lors du chargement des données', 'danger');
        } finally {
            this.setState({ isLoading: false });
        }

        if (navigator.platform.indexOf("Win") > -1) {
            ps = new PerfectScrollbar(this.mainPanel.current);
        }
    }

    componentWillUnmount() {
        if (navigator.platform.indexOf("Win") > -1) {
            ps.destroy();
        }
    }

    componentDidUpdate(e) {
        if (navigator.platform.indexOf("Win") > -1) {
            setTimeout(() => {
                ps.update();
            }, 350);
        }
        if (e.history.action === "PUSH") {
            document.documentElement.scrollTop = 0;
            document.scrollingElement.scrollTop = 0;
            this.mainPanel.current.scrollTop = 0;
        }
        if (
            window.innerWidth < 993 &&
            e.history.action === "PUSH" &&
            document.documentElement.className.indexOf("nav-open") !== -1
        ) {
            document.documentElement.classList.toggle("nav-open");
        }
    }

    showNotification = (message, color) => {
        this._notificationSystem.current.addNotification({
            title: <span data-notify="icon" className="pe-7s-info" />,
            message: (
                <div>
                    {message}
                </div>
            ),
            level: color === 'danger' ? 'error' : color,
            position: 'tc',
            autoDismiss: 5
        });
    };

    handleMiniClick = () => {
        this.setState({mini: !this.state.mini});
        document.body.classList.toggle("sidebar-mini");
    };

    getRoutes = routes => {
        return routes.map((prop, key) => {
            if (prop.collapse) {
                return this.getRoutes(prop.views);
            }
            if(prop.redirect) {
                return (<Redirect key={key} from={prop.path} to={prop.pathTo} />);
            }
            return (
                <Route
                    path={prop.path}
                    key={key}
                    exact
                    render={routeProps => (
                        <prop.component
                            {...routeProps}
                            showNotification={this.showNotification}
                        />
                        )}
                />
            );
        }).flat();
    };

    render() {
        if (this.state.isLoading) {
            return (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    flexDirection: 'column'
                }}>
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Chargement...</span>
                    </div>
                    <p style={{ marginTop: '1rem' }}>Chargement des données...</p>
                </div>
            );
        }

        return (
            <div className="wrapper">
                <NotificationSystem ref={this._notificationSystem} style={style} />
                <Sidebar
                    {...this.props}
                    image={this.state.image}
                    color={this.state.color}
                    hasImage={this.state.hasImage}
                    mini={this.state.mini}
                    isAdmin={this.props.isAdmin}
                />
                <div
                    className={"main-panel"}
                    ref={this.mainPanel}
                >
                    <AdminNavbar
                        {...this.props}
                        handleMiniClick={this.handleMiniClick}
                        navbar={this.state.navbar}
                        history={this.props.history}
                    />
                    <Switch>
                        {this.getRoutes(routes)}
                        <Redirect from="/app" to="/app/product/home" />
                    </Switch>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const user = state.user.currentUser;
    const userWithPermissions = addPermissionsToUserSync(user);

    // Pour test: forcer admin si l'utilisateur existe
    const isAdminTest = userWithPermissions && (
        userWithPermissions.isAdmin ||
        localStorage.getItem('testAdmin') === 'true'
    );

    return {
        user: userWithPermissions,
        isAdmin: isAdminTest
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadAllData: () => {
            dispatch(loadAllData());
        },
        loadSubstances: () => {
            dispatch(loadSubstances());
        }
    }
}

Dashboard.propTypes = {
    history: PropTypes.object,
    loadAllData: PropTypes.func,
    loadSubstances: PropTypes.func,
    user: PropTypes.object,
    isAdmin: PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
